<script>
    export let name = "";
    export let url = "";
    import { link } from "svelte-routing";
    import { appSettings } from "../../stores";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    function closeMenu() {
        dispatch('closeMenu');
    }

    function setActive() {
        // $appSettings.currentPageLink = url;
        // $appSettings.currentPageName = name;
        closeMenu();
    }
</script>

<a href={url} use:link class="item {$appSettings.currentPageLink==url?"active":""}" on:click={setActive}>
    <div>
        <span>{name}</span>
    </div>
</a>

<style>
    .item  {
        color: white;
        font-size: 1.2rem;
    }

    .item:hover,
    .item:active,
    .item:focus  {
        color: white;
        text-decoration: none;
    }

    /* .item:active,
    .item.active,
    .item:focus  {
        color: #0060ED;
        text-decoration: none;
    } */

    .item:focus-visible {
        outline: none;
    }

    .item:focus-visible>div {
        background-color: #050505;
    }
    
    div {
        padding: 1rem 2rem;
        /* border-bottom: 1px solid #001367;; */
        display: flex;
        border-radius: 0.6rem;
        text-align: center;
    }

    span {
        width: 100%;
        text-align: center;
    }

    div:hover,
    div:focus-within {
        background-color: #242424;
    }

    i {
        margin: 0;
        padding-right: 1rem;
    }

    i::before {
        margin: 0;
    }
</style>